import { httpClient } from './api/httpClient';
import { isMockEnabled, mockResponse } from './api/mockAdapter';
import { API_ENDPOINTS } from 'constants/apiEndpoints';
import { MOCK_STORAGE2 } from 'mock/pipeline.mock';

export const toStorage2 = (raw) =>
  raw && {
    id: raw.id,
    routedFrom: raw.previous_stage?.stage ?? '',
    sourceModule: raw.workflow?.routing_destination ?? raw.source_module ?? raw.sourceModule ?? '',
    newspaperName: raw.newspaper_name ?? raw.newspaperName ?? '',
    edition: raw.edition ?? '',
    keyword: raw.keywords ?? raw.keyword ?? [],
    articleLink: raw.article_image_url ?? raw.article_link ?? raw.articleLink ?? '',
    newspaperLink: raw.newspaper_page_image_url ?? raw.newspaper_link ?? raw.newspaperLink ?? '',
    pageNumber: raw.page_number ?? raw.pageNumber ?? null,
    archivePath: raw.archive_path ?? raw.archivePath ?? '',
    archivedAt: raw.routing?.routed_at ?? raw.archived_at ?? raw.archivedAt ?? null,
    source: raw.source?.type ?? (typeof raw.source === 'string' ? raw.source : '') ?? '',
    status: raw.workflow?.status ?? raw.status ?? 'routed',
    workflow: raw.workflow ?? null,
    routing: raw.routing ?? null,
    createdAt: raw.created_at ?? raw.createdAt ?? null,
    notes: raw.notes ?? null,
  };

const articles = MOCK_STORAGE2.map((r) => ({ ...r }));

export const storage2Service = {
  async list(params = {}) {
    if (isMockEnabled()) {
      let filtered = articles;
      if (params.newspaper_name) {
        filtered = filtered.filter(a => a.newspaper_name === params.newspaper_name || a.newspaperName === params.newspaper_name);
      }
      return (await mockResponse(filtered)).map(toStorage2);
    }
    const data = await httpClient.get(API_ENDPOINTS.STORAGE2.LIST, { params });
    return (Array.isArray(data) ? data : data.items ?? []).map(toStorage2);
  },
};

export default storage2Service;
